import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { PromptLibraryNavigation } from "@/components/PromptLibraryNavigation";
import SEO from "@/components/SEO";
import { AIWorkflowLibrary } from "./AIWorkflowLibrary";
import { library } from "@/data/aiWorkflows";
import { usePromptLibraryReferral } from "@/hooks/use-prompt-library-referral";
import { trackEvent } from "@/utils/posthog";
import { useHydratedSearch } from "@/hooks/useHydratedSearch";
import { promptLibraryCampaignQuery } from "@/utils/promptLibraryConversion";
import {
  LIBRARY_PATH,
  shareImage,
  workflowPath,
} from "@/utils/promptLibraryShare";

export default function PromptLibraryWorkflow() {
  const { pathname } = useLocation();
  const campaignQuery = promptLibraryCampaignQuery(useHydratedSearch());
  const entry = library.find(
    (item) => workflowPath(item.slug) === pathname.replace(/\/+$/, ""),
  );
  usePromptLibraryReferral();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (entry)
      trackEvent("Prompt Library Workflow Viewed", {
        source_page: "fortune-100-prompt-library",
        workflow_slug: entry.slug,
        category: entry.category.id,
      });
  }, [pathname, entry]);
  if (!entry)
    return <a href={LIBRARY_PATH}>Explore the workflow library</a>;
  return (
    <div className="min-h-screen bg-longhand-paper">
      <SEO
        robots="noindex, nofollow, noarchive, nosnippet"
        title={`${entry.title} - AI Workflow`}
        description={`${entry.purpose} First-run prompt, sources, review checks, and reusable instructions.`}
        image={shareImage(entry.slug)}
        imageAlt={`${entry.title}. AI workflow with a prompt, sources, and review checks.`}
        imageWidth={1200}
        imageHeight={630}
      />
      <PromptLibraryNavigation />
      <main>
        <header className="bg-longhand-paper px-4 pb-6 pt-28 text-longhand-ink sm:px-6">
          <div className="mx-auto max-w-6xl">
            <a
              href={`${LIBRARY_PATH}${campaignQuery}`}
              className="text-xs font-bold uppercase tracking-widest text-longhand-accent"
            >
              The Fortune 100 AI Prompt Library™
            </a>
            <h1 className="mt-4 max-w-4xl font-serif text-4xl font-semibold tracking-tight sm:text-5xl">
              {entry.title}
            </h1>
            <p className="mt-4 max-w-3xl text-lg text-longhand-ink/80">
              {entry.purpose}
            </p>
            <p className="mt-4 text-sm text-longhand-ink/80">
              For Claude or ChatGPT
            </p>
          </div>
        </header>
        <AIWorkflowLibrary key={entry.slug} selectedWorkflow={entry} />
      </main>
    </div>
  );
}
